import Base from './components/cells/Base';
import MultiValue from './components/cells/MultiValue';

export default function MultiValueCell() {}

MultiValueCell.prototype.init = function (params) {
    this.eGui = Base(MultiValue(params), params);
    return;
};

MultiValueCell.prototype.getGui = function () {
    return this.eGui;
};
